import { ButtonMain } from '../button';
import styles from './index.module.sass';
import supportImg from '@@/common/images/support.svg';
import { ReactNode } from 'react';

export const PlaceholderEmpty = ({
  title,
  label,
  action,
  image,
}: {
  title: ReactNode;
  label?: ReactNode;
  action?: { text: string; action: () => void };
  image?: string;
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.innerArea}>
        <img src={image || supportImg} alt="img" className={styles.image} />
        <div className={styles.textArea}>
          <span className={styles.title}>{title}</span>
          {label && <span className={styles.label}>{label}</span>}
        </div>
        {action && <ButtonMain className={styles.action} label={action?.text} onClick={action.action} />}
      </div>
    </div>
  );
};
